const UserMenuHandle = Object.freeze({
	OpenProfile: 'openProfile',
	OpenPrefer: 'openPreference',
	CloseProfile: 'closeProfile',
	ClosePrefer: 'closePreference',
});

export { UserMenuHandle };
